import React, { useEffect, useState } from "react";
import TextInput from "../../../../components/common/input/TextInput";
import { useOrderContext } from "../../OrderPage";
import { useSelector } from "react-redux";

function Note() {
  const { currentHd } = useSelector((state: any) => state.order);
  const { handleUpdateCurrentHd } = useOrderContext();
  const [text, setText] = useState<string>("");

  useEffect(() => {
    setText(currentHd?.dien_giai || "");
  }, [currentHd?.dien_giai]);

  return (
    <TextInput
      direction="column"
      minRows={3}
      placeholder="Ghi chú đơn hàng"
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={() => {
        handleUpdateCurrentHd({ dien_giai: text });
      }}
    />
  );
}

export default Note;
